import React from 'react';
import { Hero } from './components/Hero';
import { Products } from './components/Products';
import { HowItWorks } from './components/HowItWorks';
import { InstagramSection } from './components/InstagramSection';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
function App() {
  return <div className="min-h-screen bg-stone-50 font-sans selection:bg-rose-200 selection:text-rose-900" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <Products data-id="element-3" />
        <HowItWorks data-id="element-4" />
        <InstagramSection data-id="element-5" />
      </main>
      <Footer data-id="element-6" />
      <WhatsAppButton data-id="element-7" />
    </div>;
}
export { App };